import type { SettingsSection } from "../types";

export * from "./constants";

export const groupSectionsByCategory = (
  sections: SettingsSection[]
): Record<string, SettingsSection[]> => {
  return sections.reduce(
    (acc, section) => {
      if (!acc[section.category]) {
        acc[section.category] = [];
      }
      acc[section.category].push(section);
      return acc;
    },
    {} as Record<string, SettingsSection[]>
  );
};

export const getCurrentSectionFromUrl = (pathname: string): string => {
  const pathSegments = pathname.split("/");
  const sectionFromUrl = pathSegments[pathSegments.length - 1];

  return sectionFromUrl;
};
